import { combineReducers } from 'redux';

import data from './data';
import loading from './loading';

export default combineReducers({
    data,
    loading
});
